import { Eye } from "lucide-react";
import { type ReactNode, useId } from "react";
import type { Conference } from "../api.js";

export type WorkspacePreviewProps = { conference: Conference };

export function PreviewFrame({ title, description, action, operationalNote, children }: { title: string; description: string; action?: ReactNode; operationalNote: string; children: ReactNode }) {
  const titleId = useId();
  return <section className="workspace-preview" aria-labelledby={titleId}>
    <header className="preview-frame-header"><div><span className="preview-frame-kicker"><Eye aria-hidden="true" size={15} />Live workspace</span><h1 id={titleId}>{title}</h1><p>{description}</p></div>{action}</header>
    <p className="preview-frame-note is-operational">{operationalNote}</p>
    {children}
  </section>;
}
